var t = function (t, o, e) {
  if (!o.hasOwnProperty(e)) {
    var r = Object.getOwnPropertyDescriptor(t, e);
    Object.defineProperty(o, e, r);
  }
};
export default {
  props: {
    template: String,
    parent: Object,
    templateProps: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  render: function (o) {
    if (this.template) {
      var e = this.parent || this.$parent,
        r = e.$data;
      void 0 === r && (r = {});
      var n = e.$props;
      void 0 === n && (n = {});
      var a = e.$options;
      void 0 === a && (a = {});
      var p = a.components;
      void 0 === p && (p = {});
      var c = a.computed;
      void 0 === c && (c = {});
      var i = a.methods;
      void 0 === i && (i = {});
      var s = this.$data;
      void 0 === s && (s = {});
      var d = this.$props;
      void 0 === d && (d = {});
      var v = this.$options;
      void 0 === v && (v = {});
      var f = v.methods;
      void 0 === f && (f = {});
      var m = v.computed;
      void 0 === m && (m = {});
      var u = v.components;
      void 0 === u && (u = {});
      var h = {
        $data: {},
        $props: {},
        $options: {},
        components: {},
        computed: {},
        methods: {}
      };
      Object.keys(r).forEach(function (t) {
        void 0 === s[t] && (h.$data[t] = r[t]);
      }), Object.keys(n).forEach(function (t) {
        void 0 === d[t] && (h.$props[t] = n[t]);
      }), Object.keys(i).forEach(function (t) {
        void 0 === f[t] && (h.methods[t] = i[t]);
      }), Object.keys(c).forEach(function (t) {
        void 0 === m[t] && (h.computed[t] = c[t]);
      }), Object.keys(p).forEach(function (t) {
        void 0 === u[t] && (h.components[t] = p[t]);
      });
      var O = Object.keys(h.methods || {}),
        $ = Object.keys(h.$data || {}),
        b = Object.keys(h.$props || {}),
        j = Object.keys(this.templateProps),
        y = $.concat(b).concat(O).concat(j),
        k = (E = e, P = {}, O.forEach(function (o) {
          return t(E, P, o);
        }), P),
        l = function (o) {
          var e = {};
          return o.forEach(function (o) {
            o && Object.getOwnPropertyNames(o).forEach(function (r) {
              return t(o, e, r);
            });
          }), e;
        }([h.$data, h.$props, k, this.templateProps]);
      return o({
        template: this.template || "<div></div>",
        props: y,
        computed: h.computed,
        components: h.components,
        provide: this.$parent._provided
      }, {
        props: l
      });
    }
    var E, P;
  }
};